<template>
  <div id="side-data" :class="{ 'no-scroll': isEmptyList() }">
    <div class="loggedUser" v-if="getUser">
      <div class="cont-name">
        <h3>
          <i class="fas fa-user-check"></i>
          {{ getUser.name }}
        </h3>
      </div>
      <div class="cont-icon-exit" v-if="getUser">
        <a class="btn-salid-session" title="Salir" @click="singout()">
          <i class="fa fa-sign-out" aria-hidden="true"></i>
        </a>
      </div>
    </div>
    <h2 v-t="'sidebar.titulo'"></h2>
    <form class="rangeForm">
      <div class="row">
        <div class="left-label">{{ $t("sidebar.inicio") }}:</div>
        <div class="right-field">
          <flat-pickr
            v-model="date"
            id="input_fecha_inicio"
            :placeholder="$t('sidebar.selec_fecha')"
            @on-change="onChangeStartDate"
            :config="options_flatpickr"
          ></flat-pickr>
        </div>
      </div>
      <div class="row">
        <div class="left-label">{{ $t("sidebar.duracion") }}:</div>
        <div class="right-field">
          <select v-model="duration_banners" @change="onChangeDuration($event)">
            <option value="15">15 {{ $t("sidebar.dias") }}</option>
            <option value="30">30 {{ $t("sidebar.dias") }}</option>
            <option value="45">45 {{ $t("sidebar.dias") }}</option>
            <option value="60">60 {{ $t("sidebar.dias") }}</option>
            <option value="90">3 {{ $t("sidebar.meses") }}</option>
            <option value="182">6 {{ $t("sidebar.meses") }}</option>
          </select>
        </div>
      </div>
    </form>

    <div class="cont_not_espacios" v-if="isEmptyList()">
      <p v-t="'sidebar.lista_vacia'"></p>
    </div>

    <div
      class="cont_espacios"
      v-for="(item1, index) in getListSpacesBillboardsToShow"
      :key="index + '_cont_espacios'"
    >
      <h3>{{ item1.titulo }}</h3>
      <div
        class="item"
        v-for="(item2, indx) in item1.vallas"
        :key="indx + 'item_espacio'"
      >
        <a @click="openInfoModal(item2)" class="title_espacio">
          <h4>{{ item2.direccion }}</h4>
        </a>
        <div class="action">
          <a
            href="#confirmDeleteModal"
            data-bs-toggle="modal"
            data-bs-target="#confirmDeleteModal"
            title="Remover"
            @click="setInfoParent(item2)"
          >
            <i class="far fa-trash-alt"></i>
          </a>
        </div>
        <h5 v-if="(item2.type_id === 2 || item2.part_circuit) && item2.subtitle" class="cart-subtitle">{{item2.subtitle}}</h5>
        <h5 v-if="item2.type_id !== 2 && !item2.part_circuit ">
          <i class="fas fa-street-view" title="De cara hacia el..."></i>
          {{ returnDir(item2.de_cara_al).name }}
        </h5>
      </div>
    </div>
  </div>
  <!-- #side-data -->
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import * as vallas_request from "../request/vallas.js";

//import ConfirmBorrar from "./Modales/ConfirmBorrar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es";

import Snackbar from "node-snackbar";

//mixins
import VallasMixin from "../mixins/vallas";
let $ = null;

export default {
  props: ["lista_espacios", "cardinal_directions", "duration", "start_date"],
  mixins: [VallasMixin],
  components: {
    //    "confirm-borrar": ConfirmBorrar,
    flatPickr,
  },
  created() {
    var vm = this;
    this.$root.$on("EvemtRemoveListEspacio", function (id) {
      vm.removeFromList(id);
    });
    //  window.removeEventListener("resize", this.resizeEvent);
    $ = window.$;
  },
  mounted() {
    /* window.addEventListener("resize", this.resizeEvent);

    setTimeout(function () {
      if (window.innerHeight > window.innerWidth) {
        $("#useLandscapeModal").modal("show");
      }
    }, 2000);
 */
    //  Hide confirmation in 7 seconds
    $("#confirmCotizModal").on("shown.bs.modal", function () {
      setTimeout(function () {
        $("#confirmCotizModal").modal("hide");
      }, 7000);
    });
  },
  computed: {
    ...mapGetters(["getUser", "getToken", "getListSpacesBillboards", "getDurationSpaces", "getStartDateSpaces"]),
    getListSpacesBillboardsToShow() {
      return this.getListSpacesBillboards.filter(
        (item) => item.vallas.length > 0
      );
    },
  },
  data() {
    return {
      options_flatpickr: {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        minDate: new Date().fp_incr(3), // aumenta 3 dias
        locale: Spanish, // locale for this instance only
      },
      date: this.start_date,
      duration_banners: this.duration,
    };
  },
  methods: {
    ...mapActions(["changueUser", "changueToken", "cleanListSpacesBillboards", "change_start_date_spaces", "change_duration_spaces",]),
    // Elimina un lemento de la lista
    removeFromList: function (id_ciudad, id) {
      this.removeFromList({
        location_id: id_ciudad,
        id,
      });
    },
    // verifica si la lista esta vacia
    isEmptyList() {
      let count = 0;
      this.getListSpacesBillboards.map((item) => {
        item.vallas.length > 0 ? count++ : null;
      });
      if (count == 0) {
        return true;
      } else {
        return false;
      }
    },
    setInfoParent(data) {
      this.$parent.setInfo(data);
    },
    onChangeDuration(event) {
      this.change_duration_spaces(event.target.value)
        },
        onChangeStartDate(event) {
          this.change_start_date_spaces(event)
        },
    returnData() {
      let error_ = false;
      if (this.date == null) {
        error_ = true;
        return false;
        //      alert('Debes selecionar una fecha.');
      }
      // si no hay errores
      if (!error_) {
        let vallas_ = [];
        // reviso cada espacio
        this.lista_espacios.map((item) => {
          // agrego a la variable vallas_ los grupos registrados
          item.vallas.length > 0 ? vallas_.push(item.vallas) : null;
        });
        return {
          date: this.date,
          duration: this.duration_banners,
          vallas: vallas_,
        };
      }
    },
    resetData() {
      this.$parent.resetList();
      this.date = null;
    },
    openInfoModal(marker) {
      var vm = this;
      vallas_request.get(marker.id_valla).then(function (response) {
        vm.$parent.$refs.detalles_valla_modal.show(response.data.data);
      });
    },
    singout() {
      this.changueUser(null);
      this.changueToken(null);

      Snackbar.show({
        text: "Has cerrado la session.",
        pos: "bottom-center",
        backgroundColor: "#1D0E54",
        actionTextColor: "#ee5b66",
        actionText: "<b>Cerrar</b>",
      });
    },
    resizeEvent() {
      //  Alert appear on device rotation
      if (window.innerHeight > window.innerWidth) {
        $("#useLandscapeModal").modal("show");
      }
    },
  },
};
</script>

<i18n src="@/locale/modals/generic.json" />
<i18n src="@/locale/layout/sidebar.json" />
